export enum NodeType {
	Article,
	Outfit,
	Product,
	Shop,
	WardrobeItem,
	User,
	ArticleComment,
}
